export default __webpack_public_path__ + "img/linecirclefirstenh5.b22634ed.svg";